import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import moment from 'moment'
import PlannedConsultationEditor from './PlannedConsultationEditor'
import { ConsultationFormData } from './_props'
import SlackNotifications from '../../../slackNotifications'
import { useAppDispatch } from '../../../store'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { displaySnackbar } from '../../../actions/main'

export const PlannedConsultationCreation = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { id: hcsId } = useCurrentHcs()
    const [emptyConsultation] = useState({
        patientId: '',
        patientLibelle: '',
        requiredExpertId: '',
        requiredExpertLibelle: '',
        appointmentDate: null,
    })

    const saveNewConsultation = async (data: ConsultationFormData) => {
        try {
            const consultation = new ToktokdocLib.Consultation()
            await consultation.plan(
                hcsId,
                data.patientId,
                data.requiredExpertId,
                moment(data.appointmentDate, 'YYYY-MM-DDTHH:mm').toDate(),
            )

            SlackNotifications.createPlannedConsultation(consultation)

            navigate(`/planned-consultation/${consultation.id}`)
            dispatch(
                displaySnackbar(
                    'success',
                    'La téléconsultation prévue a bien été créée',
                    undefined,
                    `[PlannedConsultationEditor] création téléconsultation préparée ${consultation.id}`,
                ),
            )
        } catch (saveError) {
            console.log(`error create consul: ${JSON.stringify(saveError, null, 2)}`)
        }
    }

    return (
        <PlannedConsultationEditor
            consultationDetail={emptyConsultation}
            isNewConsultation
            onSave={saveNewConsultation}
        />
    )
}
